import React, { Component } from 'react'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import CodeModal from '../components/CodeModal'
import PatientsTable from '../components/PatientsTable'
import { withStyles } from '@material-ui/core/styles';
import { getPatients } from '../api'
import { orderByDate } from '../utils'

const styles = theme => ({
  page: {
    display: 'flex',
    justifyContent: 'center',
    height: 'calc(100% - 90px)',
    overflow: 'scroll'
  },
  pageContent: {
    width: '80%',
    maxWidth: 1200
  },
  tab: {
    textTransform: 'none'
  },
  buttons: {
    marginTop: 100,
    marginBottom: 50,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  patientCount: {
    display: 'flex',
    width: 150,
    justifyContent: 'space-between'
  },
  bold: {
    fontWeight: 'bold'
  }
})

class CurrentPatients extends Component {
  constructor(props) {
    super(props)

    this.state = {
      status: 'Active',
      patients: [],
      displayModal: false
    }
  }

  componentDidMount () {
    this.fetchPatients({status: 'Active'})
  }

  fetchPatients = (options = {}) => {
    getPatients(options).then(response => this.setState({patients: orderByDate(response, 'activation_date').reverse()}))
  }

  handleTabChange = (e, value) => {
    this.setState({status: value}, () => {
      this.fetchPatients({status: this.state.status})
    })
  }

  toggleModal = (e) => {
    this.setState({displayModal: !this.state.displayModal})
  }

  render () {
    const { classes } = this.props
    return (
      <main className={classes.page}>
        <CodeModal open={this.state.displayModal} onClose={this.toggleModal} />
        <div className={classes.pageContent}>
          <Tabs
            value={this.state.status}
            onChange={this.handleTabChange}
            indicatorColor="primary"
          >
            <Tab label="Patients" className={classes.tab} value="Active" />
            <Tab label="Inactive" className={classes.tab} value="Inactive" />
          </Tabs>

          <Divider />

          <Grid container className={classes.buttons}>
            <div className={classes.patientCount}>
              <Typography className={classes.bold}>Patient List</Typography>
              <Typography>{this.state.patients.length} Users</Typography>
            </div>
            <Button variant="contained" color="primary" onClick={this.toggleModal}>
              Generate Code
            </Button>
          </Grid>

          <PatientsTable patients={this.state.patients} refetch={this.fetchPatients} status={this.state.status} />
        </div>
      </main>
    );
  }
}

export default withStyles(styles)(CurrentPatients)



// WEBPACK FOOTER //
// ./src/pages/CurrentPatients.js